import type { MimeType } from "@/core/types";

/**
 * Gets the MIME type from a File object
 * Handles special case where HEIC files don't report file.type on Windows/Linux
 * @param file - The file to extract MIME type from
 * @returns The file's MIME type or null if not available/valid
 */
export function getFileMimeType(file: File | null | undefined): MimeType | null {
  if (!file) {
    return null;
  }

  // If file.type is available, use it
  if (file.type) {
    return file.type as MimeType;
  }

  // Fallback: detect HEIC files by extension on Windows/Linux
  const fileName = file.name.toLowerCase();

  if (fileName.endsWith(".heic") || fileName.endsWith(".heif")) {
    return "image/heic" as MimeType;
  }

  return null;
}
